import { useCallback } from 'react'
import { useToast } from '../ui/Toast.js'
import { cofnijZaplate, oznaczZaplacone } from './mutacje.js'
import type { Platnosc } from './typy.js'

/**
 * Odhaczanie w jednym miejscu: klik przełącza stan natychmiast, a wysyłkę
 * bierze na siebie kolejka — także wtedy, gdy telefon nie ma zasięgu.
 * To najczęstsza czynność w aplikacji, więc nie może wymagać potwierdzenia
 * ani czekania na serwer.
 */
export function useOdhaczanie(): (platnosc: Platnosc) => Promise<void> {
  const toast = useToast()

  return useCallback(
    async (platnosc: Platnosc) => {
      try {
        if (platnosc.status === 'paid') {
          await cofnijZaplate(platnosc.id)
          toast.pokaz('Cofnięto zapłatę')
          return
        }
        await oznaczZaplacone(platnosc.id)
        toast.pokaz('Oznaczono jako zapłacone', {
          etykieta: 'Cofnij',
          wykonaj: () => cofnijZaplate(platnosc.id),
        })
      } catch (problem) {
        toast.pokazBlad(problem instanceof Error ? problem.message : 'Nie udało się zapisać zmiany')
      }
    },
    [toast],
  )
}
